import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import './University.css'
import Navbar from '../component/Navbar';

export default function University() {
    const { slug } = useParams();
    const url = window.location.origin;  
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const [loading, setLoading] = useState(true);
    const [university, setUniversity] = useState(null);
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;
    const URL_GET_UNIVERSITY = `${process.env.REACT_APP_API_BASE_URL}api/studyabroad/public/request/university/`;
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (appLogo) {
            fetchData(`${URL_GET_UNIVERSITY}?slug=${slug}`).then((value) => {
                setUniversity(value.data);
            });            
        }
    }, [slug]);

    useEffect(() => {
        fetchData(URL_GET_PROJECT).then((value) => {
            setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${value.data.logo}`)
        });
    }, [domain]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen}/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <div className="university-detail">
                <div className="university-banner">
                    <img
                        src={`${process.env.REACT_APP_API_BASE_URL}/upload/${university?.image_photo}`}
                        alt={`${university?.name} Banner`}
                        className="university-banner-img"
                    />
                </div>

                <div className="university-info">
                    <div className="university-logo">
                        <img
                            src={`${process.env.REACT_APP_API_BASE_URL}/upload/${university.image_logo}`}
                            alt={`${university.name} Logo`}
                            className="university-logo-img"
                        />
                    </div>
                    <h1>{university.name}</h1>
                    <p>{university.description}</p>
                    <p><strong>Country:</strong> {university.country}</p>
                    <p><strong>City:</strong> {university.city}</p>
                    <p><strong>Phone:</strong> {university.phone}</p>
                    <a href={university.website} target="_blank" rel="noopener noreferrer">
                        Visit Website
                    </a>
                </div>

                {/* <div className="university-programs">
                    <h2>Programs Offered</h2>
                    {programs.length > 0 ? (
                        <ul>
                            {programs.map((program) => (
                                <li key={program.id} className="program-item">
                                    <h3>{program.name}</h3>
                                    <p>{program.description}</p>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No programs available at this time.</p>
                    )}
                </div> */}
            </div>
        </div>
    )
}
